export default "__VITE_ASSET__DbxP1Vcg__"